import { render, staticRenderFns } from "./TipologiaAttivita.vue?vue&type=template&id=281d3718"
import script from "./TipologiaAttivita.vue?vue&type=script&lang=js"
export * from "./TipologiaAttivita.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports